@if(isPageInitialized) {
  <div class="dashboard-wrapper" *transloco="let t; prefix: 'accidents'">
    <div class="dashboard-top-section d-flex align-items-center justify-content-between">
      <h1>{{ t('page.title') }}</h1>

      <div class="search-menu-lists d-flex">
        <div class="filters d-flex align-items-center gap-2">
          <app-search [placeholder]="t('page.searchPlaceholder')" [searchTerm]="searchTerm" [customWidth]="'220px'"
            (searchTermUpdated)="onSearchTermUpdated($event)">
          </app-search>

          <app-account-filter [filter]="accountFilter" (filterChanged)="onAccountFilterChange($event)"></app-account-filter>

          <div class="common-drop-down date-height">
            <app-date-filter [filter]="dateFilter" [isButtonIntervalSelector]="false"
              [disabledIntervals]="disabledIntervals" [defaultInterval]="defaultInterval"
              (filterChanged)="onDateFilterChange($event)">
            </app-date-filter>
          </div>

          <span ngbDropdown class="accident-type-filter" [autoClose]="true">
            <button type="button" class="btn accident-type-filter-btn form-control dropdown-toggle search-input"
              id="accidentTypeFilterDropdown" ngbDropdownToggle>
              <div class="d-flex flex-row justify-content-between dropdown-inner">
                <span class="align-middle">{{ accidentTypeLabelKey | transloco }}</span>
                <i class="ph ph-caret-down lh-base"></i>
              </div>
            </button>
            <div ngbDropdownMenu aria-labelledby="accidentTypeFilterDropdown">
              <div class="d-flex flex-column">
                @for (accidentType of accidentTypes; track accidentType) {
                  <button class="btn btn-outline" (click)="onAccidentTypeFilter(accidentType)" ngbDropdownItem>{{ accidentTypeLabelKeys[accidentType] | transloco }}</button>
                }
              </div>
            </div>
          </span>

          <button class="btn-report-incident" (click)="onReportIncident()">
            {{ t('page.reportIncident') }}
          </button>
        </div>
      </div>
    </div>

    <div class="dashboard-content">
      <div class="tabs-container w-100">
        @for (tab of tabs; track tab) {
          <button class="tab-button" [class.active]="isTabActive(tab)" (click)="onTabChange(tab)">{{ tabLabelKeys[tab] | transloco }}</button>
        }
      </div>

      <div class="tab-content-wrap w-100">
        @if (isDataFiltersReady) {
          @switch (selectedTab) {
            <!-- @case (accidentsIncidentsTab.AccidentAlerts) {
              <app-accident-alerts [selectedAccidentType]="selectedAccidentType"></app-accident-alerts>
            } -->
            @case (accidentsIncidentsTab.DetectedAccident) {
              <app-detected-accident [searchTerm]="searchTerm"></app-detected-accident>
            }
            @case (accidentsIncidentsTab.IncidentReport) {
              <app-incident-report [selectedAccidentType]="selectedAccidentType" [searchTerm]="searchTerm"></app-incident-report>
            }
          }
        }
      </div>
    </div>
  </div>
}
